import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from './CourseData';
import { Button } from 'react-bootstrap';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import { Modal, Form } from 'react-bootstrap';
import CreateCourse from './CreateCourse';
import EditCourse from './EditCourse';
import { useNavigate } from 'react-router-dom';

// Import icons (you may need to adjust paths based on your project structure)
import InfoIcon from '../../assets/images/svg/infoIcon.svg';
import EditIcon from '../../assets/images/svg/editLearning.svg';
import ArchiveIcon from '../../assets/images/svg/archiveLearning.svg';
import ArchiveEnabled from '../../assets/images/svg/archiveEnabled.svg';
import Search from '../../assets/images/svg/Search_SoS.svg';
import SearchIcon from '../../assets/images/svg/search_iconSos.svg';
import Calendar from '../../assets/images/svg/Calendar_SoS.svg';
import Filter from '../../assets/images/svg/Filter_SoS.svg';

// Import date range picker
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { _axios } from '../../utils/axios';



const CourseTable = () => {
    const navigate = useNavigate();
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showView, setShowView] = useState(false);
    const [viewRowData, setViewRowData] = useState(null);
    const [editRowData, setEditRowData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showChapters, setShowChapters] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        type: '',
        courseId: null
    });

    // New state variables for search, calendar, and filter functionality
    const [originalData, setOriginalData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const searchRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);
    const filterOptions = [
        { label: 'All', value: 'all' },
        { label: 'New', value: 'NEW' },
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Archived', value: 'ARCHIVED' }
    ];

    // Click outside handlers for search, dropdown, and calendar
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await _axios.get(`${ServerPath}/course/all`);

            if (response.data.success) {
                console.log("Response", response);
                const transformedData = response.data.data.map(item => ({
                    id: item.id,
                    course_id: item.course_id,
                    title: item.title,
                    category: item.category,
                    language: item.language,
                    course_type: formatCourseType(item.course_type),
                    created_date: formatDate(item.created_at),
                    status: formatStatus(item.status),
                    status_component: (
                        <span className="d-inline-block"
                            style={{
                                minWidth: '70px',
                                textAlign: 'center',
                                borderRadius: '20px',
                                padding: '4px 8px',
                                backgroundColor: getStatusColor(item.status),
                                color: '#FFFFFF',
                                fontSize: '10px',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                border: '1px solid rgba(255, 255, 255, 0.1)'
                            }}
                        >
                            {formatStatus(item.status)}
                        </span>
                    ),
                    action: (
                        <div className="d-flex justify-content-center gap-2">
                            <button
                                className="btn btn-link p-0"
                                title="View Chapters"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewChapters(item);
                                }}
                            >
                                <img src={InfoIcon} alt="info" style={{ width: '24px', height: '24px' }} />
                            </button>
                            <button
                                className="btn btn-link p-0"
                                title="Edit"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit({
                                        raw_data: item
                                    });
                                }}
                            >
                                <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                            </button>
                            <div title={item.status === 'Archived' ? "Archived" : "Archive"}>
                                <button
                                    className="btn btn-link p-0"
                                    disabled={item.status === 'Archived'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (item.status !== 'Archived') {
                                            setModalConfig({
                                                type: 'archive',
                                                courseId: item.course_id
                                            });
                                            setShowModal(true);
                                        }
                                    }}
                                    style={{ opacity: item.status === 'Archived' ? 0.5 : 1 }}
                                >
                                    <img src={item.status === 'Archived' ? ArchiveEnabled : ArchiveIcon} alt="archive" style={{ width: '24px', height: '24px' }} />
                                </button>
                            </div>
                        </div>
                    ),
                    raw_data: item // Store the original data for edit purposes
                }));

                setData(transformedData);
                setOriginalData(transformedData); // Store original data for filtering
                setTotalRows(transformedData.length);
            }
        } catch (error) {
            console.error('Error fetching courses:', error);
            toast.error('Failed to fetch courses');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [currentPage, perPage]);

    // Helper functions for data formatting
    const formatCourseType = (type) => {
        const typeMap = {
            'VIDEO': 'Video Course',
            'AUDIO': 'Audio',
            'TEXT': 'Text-Based Course'
        };
        return typeMap[type] || type;
    };

    const formatStatus = (status) => {
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    };

    const getStatusColor = (status) => {
        const colorMap = {
            'NEW': '#FFC107',
            'ACTIVE': '#00C853',
            'ARCHIVED': '#8B5CF6'
        };
        return colorMap[status.toUpperCase()] || '#8B5CF6';
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Search, filter and date range functions
    const handleSearch = (value) => {
        setSearchValue(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(value, selectedFilter, currentDateRange);
    };

    const handleFilterChange = (value) => {
        setSelectedFilter(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(searchValue, value, currentDateRange);
        setShowDropdown(false);
    };

    const handleDateRangeChange = (item) => {
        console.log('Date Range Selected:', item.selection);
        setDateRange([item.selection]);
        applyFiltersAndSearch(searchValue, selectedFilter, item.selection);
    };

    const clearDateFilter = () => {
        const clearedRange = {
            startDate: null,
            endDate: null,
            key: 'selection'
        };
        setDateRange([clearedRange]);
        applyFiltersAndSearch(searchValue, selectedFilter, null);
        setShowCalendar(false);
    };

    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        // Apply search filter
        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.id || '').toLowerCase().includes(searchTerm) ||
                    String(item.course_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.title || '').toLowerCase().includes(searchTerm) ||
                    String(item.category || '').toLowerCase().includes(searchTerm) ||
                    String(item.course_type || '').toLowerCase().includes(searchTerm) ||
                    String(item.status || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        // Apply status filter
        if (filterValue && filterValue !== 'all') {
            filteredData = filteredData.filter(item => {
                const rawStatus = item.raw_data?.status || '';
                return rawStatus.toUpperCase() === filterValue.toUpperCase();
            });
        }

        // Apply date filter
        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                const createdDate = new Date(item.raw_data.created_at);

                // Set time to start of day for consistent comparison
                const startDate = new Date(dateValue.startDate);
                startDate.setHours(0, 0, 0, 0);

                // Set time to end of day for consistent comparison
                const endDate = new Date(dateValue.endDate);
                endDate.setHours(23, 59, 59, 999);

                return createdDate >= startDate && createdDate <= endDate;
            });
        }

        setData(filteredData);
    };

    const handleViewDetails = (course) => {
        setViewRowData(course);
        setShowView(true);
        // Alternatively, you could navigate to a details page: 
        // history.push(`/course/${course.course_id}`);
    };

    const handleEdit = (row) => {
        if (!row) return;
        console.log("Data we have for editing:", row);

        const rawData = row.raw_data;
        if (!rawData) return;

        setEditRowData({
            title: rawData.title,
            title_mar: rawData.title_mar || '',
            title_hin: rawData.title_hin || '',
            title_guj: rawData.title_guj || '',
            short_description: rawData.short_description,
            short_description_mar: rawData.short_description_mar || '',
            short_description_hin: rawData.short_description_hin || '',
            short_description_guj: rawData.short_description_guj || '',
            course_type: rawData.course_type,
            status: rawData.status,
            category: rawData.category,
            language: rawData.language,
            course_id: rawData.course_id,
            subscription_type: rawData.subscription_type,
            thumbnail_url: rawData.thumbnail_url,
            certificate_enabled: rawData.certificate_enabled,
            created_at: rawData.created_at,
            updated_at: rawData.updated_at,
            introduction_video_url: rawData.introduction_video_url,
            journey_id: rawData.journey_id,
            deity_id: rawData.deity_id || '',
            waypoint_id: rawData.waypoint_id || '',
            waypoint_name: rawData.waypoint_name || ''
        });
        setShowEdit(true);
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    const handleEditClose = () => {
        setShowEdit(false);
        setEditRowData(null);
        fetchData();
    };

    const handleCreateClose = () => {
        setShowCreate(false);
        fetchData();
    };

    const handleViewClose = () => {
        setShowView(false);
        setViewRowData(null);
    };

    const handleChaptersClose = () => {
        setShowChapters(false);
        setViewRowData(null);
    };

    const handleViewChapters = (course) => {
        // Navigate to the ChapterTable with the course id
        navigate(`/course/${course.course_id}/chapters`);
    };

    const handleModalConfirm = async () => {
        try {
            if (modalConfig.type === 'archive') {
                const response = await _axios.put(`${ServerPath}/course/status`, {
                    course_id: modalConfig.courseId,
                    status: 'Archived'
                });

                if (response.data.success) {
                    toast.success('Course has been successfully archived');
                    fetchData();
                }
            }
        } catch (error) {
            console.error('Error archiving course:', error);
            toast.error('Failed to archive course');
        }
        setShowModal(false);
    };

    return (
        <Fragment>
            {/* <style>{tableStyles}</style> */}
            <Container fluid={true}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Courses</h4>
                    <div className="d-flex align-items-center gap-3">
                        {/* Search Component */}
                        <div className="position-relative" ref={searchRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowSearch(true)}
                            >
                                <img src={Search} alt="search" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showSearch && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '45px',
                                        left: '-180px',
                                        width: '220px',
                                        zIndex: 1000
                                    }}
                                >
                                    <div
                                        style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: '#F8F7FA',
                                                borderRadius: '6px',
                                                padding: '6px 12px'
                                            }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchValue}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    outline: 'none'
                                                }}
                                                autoFocus
                                            />
                                            <button
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => handleSearch(searchValue)}
                                            >
                                                <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Calendar Component */}
                        <div className="position-relative" ref={calendarRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowCalendar(!showCalendar)}
                            >
                                <img src={Calendar} alt="calendar" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showCalendar && (
                                <div
                                    className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '300px',
                                        zIndex: 1000,
                                        right: 0
                                    }}
                                >
                                    <style>
                                        {`
                                        .date-range {
                                            font-size: 12px !important;
                                        }
                                        .date-range .rdrMonth {
                                            width: 240px !important;
                                            padding: 0 !important;
                                        }
                                        .date-range .rdrCalendarWrapper {
                                            font-size: 12px !important;
                                            width: 240px !important;
                                            border-radius: 8px !important;
                                            overflow: hidden !important;
                                            background: white !important;
                                        }
                                        .date-range .rdrDateDisplayWrapper {
                                            display: none !important;
                                        }
                                        .rdrMonthAndYearWrapper {
                                            padding-top: 5px !important;
                                            height: 40px !important;
                                        }
                                        .rdrMonth {
                                            padding: 0 !important;
                                        }
                                    `}
                                    </style>
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={handleDateRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        ranges={dateRange}
                                        maxDate={new Date()}
                                        months={1}
                                        direction="horizontal"
                                        className="date-range"
                                        staticRanges={[]}
                                        inputRanges={[]}
                                        rangeColors={['#0066ff']}
                                        minDate={new Date("2000-01-01")}
                                        showSelectionPreview={true}
                                        showMonthAndYearPickers={true}
                                        monthDisplayFormat="MMMM yyyy"
                                        dayDisplayFormat="d"
                                        showDateDisplay={false}
                                        monthsShown={1}
                                    />
                                    <div className="d-flex justify-content-end mt-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={clearDateFilter}
                                        >
                                            Clear
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Filter Component */}
                        <div className="position-relative" ref={dropdownRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowDropdown(!showDropdown)}
                            >
                                <img src={Filter} alt="filter" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showDropdown && (
                                <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-2"
                                    style={{ width: '200px', zIndex: 1000 }}>
                                    <style>
                                        {`
                                        .form-check-label {
                                            font-weight: 400 !important;
                                        }
                                        .form-check-input[type=checkbox] {
                                            border-radius: 0 !important;
                                        }
                                    `}
                                    </style>
                                    <Form>
                                        {filterOptions.map((option) => (
                                            <Form.Check
                                                key={option.value}
                                                type="checkbox"
                                                name="filterOption"
                                                id={`filter-${option.value}`}
                                                label={option.label}
                                                checked={selectedFilter === option.value}
                                                onChange={() => handleFilterChange(option.value)}
                                            />
                                        ))}
                                    </Form>
                                </div>
                            )}
                        </div>

                        {/* Create Button */}
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            className="bg-primary"
                        >
                            Create New Course
                        </Button>
                    </div>
                </div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DataTable
                                    columns={tableColumns}
                                    data={data}
                                    selectableRows
                                    pagination
                                    paginationServer={false}
                                    paginationTotalRows={totalRows}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleDelete}
                                    progressPending={loading}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* CreateCourse component should be implemented separately */}
            {showCreate && <CreateCourse show={showCreate} onHide={handleCreateClose} />}

            {/* EditCourse component should be implemented separately */}
            {showEdit && <EditCourse
                show={showEdit}
                onHide={handleEditClose}
                courseData={editRowData}
            />}

            <ConfirmationModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onConfirm={handleModalConfirm}
                title="Are you sure?"
                message="You want to archive this course? Once archived, it will no longer be visible to users."
            />
        </Fragment>
    );
};

const ConfirmationModal = ({ show, onHide, onConfirm, title, message }) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Body className="text-center p-4">
            <div className="mb-4">
                <div className="rounded-circle bg-warning bg-opacity-10 d-inline-flex p-4 mb-3">
                    <i className="bi bi-exclamation-lg fs-4 text-warning"></i>
                </div>
                <h4>{title}</h4>
                <p className="text-secondary mb-0">{message}</p>
            </div>
            <div className="d-flex gap-2 justify-content-center">
                <Button variant="primary" className="px-4" onClick={onConfirm}>Yes</Button>
                <Button variant="danger" className="px-4" onClick={onHide}>Cancel</Button>
            </div>
        </Modal.Body>
    </Modal>
);

export default CourseTable;